import { useEffect } from "react";
import { Alert, Button } from "react-bootstrap";
import Popup from "./Popup";

const ApiResponsePopup = ({
  hideHandlerRes = () => {},
  isRecordAdded = false,
  isRecordUpdated = false,
  isUploading = false,
  successMsg = "Successfully added!",
  title = "",
  errorRes = null,
}) => {
  useEffect(() => {
    if (isRecordAdded || isRecordUpdated || isUploading) {
      setTimeout(() => {
        hideHandlerRes();
      }, 30000);
    }
  }, [isRecordAdded, isRecordUpdated, isUploading, hideHandlerRes]);
  return (
    <Popup
      size="md"
      onHide={hideHandlerRes}
      footer={
        <>
          <Button variant="outline-secondary model-btn" onClick={(e) => hideHandlerRes(e)}>
            Ok
          </Button>
        </>
      }
      show={isRecordAdded || isRecordUpdated}
      title={title}
    >
      {errorRes !== null ? (
        <Alert variant={"danger"}>{errorRes}</Alert>
      ) : (
        <Alert variant={"success"}>{successMsg}</Alert>
      )}
    </Popup>
  );
};

export default ApiResponsePopup;
